<script lang="ts">
import Navigation from "@/Components/Generics/Navigation.vue";
import NavigationLink from "@/Components/NavigationLink.vue";
import AppBase from "@/Layouts/AppBase.vue";
import { NavigationLinkType } from "@/Types";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        AppBase,
        Navigation,
        NavigationLink,
    },
    computed: {
        routes(): Array<NavigationLinkType> {
            return [
                {
                    hrefRoute: "dashboard",
                    pageRoute: "/dashboard",
                    title: this.$trans("navigation.nav_school_dashboard"),
                },
                {
                    title: this.$trans("navigation.nav_acp_logout"),
                    hrefRoute: "logout",
                    inertiaLinkObj: {
                        inertiaAs: "button",
                        inertiaMethod: "post",
                        inertiaPowerOff: true,
                    },
                },
            ];
        },
    },
});
</script>

<template>
    <AppBase>
        <template #navigation>
            <Navigation>
                <template v-if="$page.props.auth.user">
                    <NavigationLink
                        v-for="route in routes"
                        :key="route.title"
                        :href-route="route.hrefRoute"
                        :href="route.href"
                        :page-route="route.pageRoute"
                        :title="route.title"
                        :not-a-link="route.notALink"
                        :inertia-link-obj="route.inertiaLinkObj" />
                </template>
            </Navigation>
        </template>
        <template #content>
            <slot></slot>
        </template>
    </AppBase>
</template>
